/* import __COLOCATED_TEMPLATE__ from './in-manual-review.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();